export const getWxParams = {
  url: 'share/link/sign',
  type: 'GET',
};
export const login = {
  url: 'login',
  type: 'POST',
};
export const getMenu = {
  url: 'user/all/menu',
  type: 'GET',
};
export const getUserMenu = {
  url: 'user/all/auth/menu',
  type: 'GET',
};
export const getLoginInfo = {
  url: 'cooperation/company/name',
  type: 'GET',
};
export const users = {
  url: 'users',
  type: 'GET',
};
export const user = {
  url: 'user',
  type: 'POST',
};
export const userDetail = {
  url: 'user/detail',
  type: 'GET',
};
export const userReset = {
  url: 'user/reset',
  type: 'POST',
};
export const userDel = {
  url: 'user/del',
  type: 'POST',
};
export const userAllDel = {
  url: 'del/user/all',
  type: 'POST',
};
export const storeAdd = {
  url: 'store',
  type: 'POST',
};
export const getregion = {
  url: 'store/load/region',
  type: 'GET',
};
export const storeUpdate = {
  url: 'store/update',
  type: 'POST',
};
export const uploadFile = {
  url: 'upload/file',
  type: 'POST',
};
export const storeGet = {
  url: 'store',
  type: 'GET',
};
export const getLimit = {
  url: 'user/quote/limit',
  type: 'GET',
};
export const saveLimit = {
  url: 'user/quote/limit',
  type: 'POST',
};
export const quotesCrabAdd = {
  url: 'quotes/crab',
  type: 'POST',
};
export const quotesAdd = {
  url: 'quotes',
  type: 'POST',
};
export const getPosterData = {
  url: 'quotes/last/quote/share',
  type: 'GET',
};
export const quoteDict = {
  url: 'quote/dict',
  type: 'GET',
};
export const quotesList = {
  url: 'quotes',
  type: 'GET',
};
export const quoteLast = {
  url: 'quote/last',
  type: 'GET',
};
export const quoteTypeLast = {
  url: 'quote/last/quote/type',
  type: 'GET',
};
export const quoteLimit = {
  url: 'quote/limit',
  type: 'GET',
};
export const getnotices = {
  url: 'back/notices',
  type: 'GET',
};
export const getnotice = {
  url: 'back/notice',
  type: 'GET',
};
export const savenotice = {
  url: 'back/notice',
  type: 'POST',
};
export const deletenotice = {
  url: 'back/notice/delete',
  type: 'POST',
};
export const accessrecord = {
  url: 'access/record',
  type: 'GET',
};
export const adimages = {
  url: 'ad',
  type: 'POST',
};
export const updateimages = {
  url: 'ad',
  type: 'POST',
};
export const getad = {
  url: 'ad',
  type: 'GET',
};
export const getads = {
  url: 'ads',
  type: 'GET',
};
export const quoteadimages = {
  url: 'quote/ad/images',
  type: 'GET',
};
export const deleteimages = {
  url: 'ad/delete',
  type: 'POST',
};
export const getquotebottombuttons = {
  url: 'quote/bottom/buttons',
  type: 'GET',
};
export const getbottombuttons = {
  url: 'bottom/buttons',
  type: 'GET',
};
export const addbottombuttons = {
  url: 'bottom/buttons',
  type: 'POST',
};
export const delbottombuttons = {
  url: 'bottom/buttons/del',
  type: 'POST',
};
export const updatebottombuttons = {
  url: 'bottom/buttons/update',
  type: 'POST',
};
// 库虾
export const getInventoryShrimpInfo = {
  url: 'stock/info',
  type: 'GET',
};
export const saveInventoryShrimpInfo = {
  url: 'stock/info',
  type: 'POST',
};
export const getStockInfo = {
  url: 'stock/info',
  type: 'GET',
};
export const getStockInfoList = {
  url: 'stock/list',
  type: 'GET',
};
export const getStockInfoItem = {
  url: '',
  type: 'GET',
};
export const saveStockInfo = {
  url: '',
  type: 'GET',
};
export const removeStockInfo = {
  url: '',
  type: 'GET',
};
export const getStockCompanyList = {
  url: 'stock/company',
  type: 'GET',
};
export const getStockCompanyOptions = {
  url: 'stock/company/dropdown',
  type: 'GET',
};
export const publishStock = {
  url: 'stock/publish',
  type: 'POST',
};
export const lastStock = {
  url: 'stock/last',
  type: 'GET',
};
export const getStockCompanyItem = {
  url: '',
  type: 'GET',
};
export const saveStockCompany = {
  url: 'stock/company',
  type: 'POST',
};
export const removeStockCompany = {
  url: '',
  type: 'GET',
};
export const getStockCategoryList = {
  url: 'stock/jargon',
  type: 'GET',
};
export const getStockCategoryOptions = {
  url: 'stock/jargon/dropdown',
  type: 'GET',
};
export const saveStockCategory = {
  url: 'stock/jargon',
  type: 'POST',
};
export const removeStockCategory = {
  url: '',
  type: 'GET',
};
// 黑名单
export const getBlackList = {
  url: 'blacklist',
  type: 'GET',
};
export const getBlackListDetail = {
  url: '',
  type: 'GET',
};
export const saveBlack = {
  url: 'update/blacklist',
  type: 'POST',
};
export const addBlack = {
  url: 'save/blacklist',
  type: 'POST',
};
export const approveBlack = {
  url: 'blacklist/approve',
  type: 'POST',
};
export const rejectBlack = {
  url: 'blacklist/reject',
  type: 'POST',
};
// 省份
export const displaydict = {
  url: 'quotes/display/dict',
  type: 'GET',
};
export const saveSyncRule = {
  url: 'store/quote/sync/rule',
  type: 'POST',
};
export const getSyncRule = {
  url: 'store/quote/sync/rule',
  type: 'GET',
};
export const quotesQuery = {
  url: 'quotes/query',
  type: 'GET',
};
export const quotesCheck = {
  url: 'quotes/check',
  type: 'GET',
};
export const getstatistics = {
  url: 'quotes/query/statistics',
  type: 'GET',
};
// #region 行情相关start
// #region 行情类型
export const updateMarketType = {
  url: 'update/quotation/type',
  type: 'POST',
};
export const addMarketType = {
  url: 'save/quotation/type',
  type: 'POST',
};
export const getMarketTypeList = {
  url: 'list/quotation/type',
  type: 'GET',
};
// #endregion 行情类型
// #region 行情价格start
export const getMarketVarieties = {
  url: 'quotation/varieties',
  type: 'GET',
};
export const getMarketPriceOptions = {
  url: 'init/publish/quotation',
  type: 'GET',
};
export const publishMarketPrice = {
  url: 'publish/quotation',
  type: 'POST',
};
export const publishCrabMarketPrice = {
  url: 'publish/quotation/crab',
  type: 'POST',
};
export const getMarketPrice = {
  url: 'list/quotation',
  type: 'GET',
};
export const getLastMarketPrice = {
  url: 'last/publish/quotation',
  type: 'GET',
};
// #endregion 行情价格
// #endregion 行情相关
export const getConnectionsList = {
  url: 'customers',
  type: 'GET',
};
export const changeMemberStatus = {
  url: 'customer/status',
  type: 'POST',
};
export const changeMemberAccreditationStatus = {
  url: 'customer/accreditation/status',
  type: 'POST',
};
export const getSalesList = {
  url: 'requirements',
  type: 'GET',
};
export const approveSalesStatus = {
  url: 'requirement/approve',
  type: 'POST',
};
export const refuseSalesStatus = {
  url: 'requirement/reject',
  type: 'POST',
};
export const getSalesInit = {
  url: 'requirements/init',
  type: 'GET',
};
export const getArticleDicts = {
  url: 'news/init',
  type: 'POST',
};
export const getArticleList = {
  url: 'list/news',
  type: 'GET',
};
export const addArticle = {
  url: 'news',
  type: 'POST',
};
export const updateArticle = {
  url: 'news',
  type: 'PUT',
};
export const publishArticle = {
  url: 'news/released',
  type: 'POST',
};
export const getArticleDetail = {
  url: 'news/backend',
  type: 'GET',
};
export const getArticleDetailMp = {
  url: 'mini/news',
  type: 'GET',
};
export const deleteArticle = {
  url: 'news',
  type: 'DELETE',
};
export const getOriginMarketList = {
  url: 'markets',
  type: 'GET',
};
export const saveOriginMarket = {
  url: 'market',
  type: 'POST',
};
export const getOriginMarket = {
  url: 'market',
  type: 'GET',
};
export const deleteOriginMarket = {
  url: 'market',
  type: 'DELETE',
};
export const getMemberOriginMarket = {
  url: 'market/store',
  type: 'GET',
};

export const approveMarketStatus = {
  url: 'market/store/approve',
  type: 'POST',
};
export const rejectMarketStatus = {
  url: 'market/store/reject',
  type: 'POST',
};
export const getMarketInit = {
  url: 'market/store/condition',
  type: 'GET',
};
/** ************************* 门店 start ****************************** */
export const getStoreApplyList = {
  url: 'stores',
  type: 'GET',
};
export const getStoreDetail = {
  url: 'store',
  type: 'GET',
};
export const getStoreApplyInit = {
  url: 'store/condition',
  type: 'GET',
};
export const storeApprove = {
  url: 'store/approve',
  type: 'POST',
};
export const storeReject = {
  url: 'store/reject',
  type: 'POST',
};
export const storeEdit = {
  url: 'store/edit',
  type: 'POST',
};
export const getStoreComplaintList = {
  url: 'store/complaints',
  type: 'GET',
};
/** ************************* 门店 end ****************************** */
/** ************************* 源头企业 start ****************************** */
export const getOriginEnterpriseApplyList = {
  url: 'enterprises',
  type: 'GET',
};
export const getOriginEnterpriseDetail = {
  url: 'enterprise',
  type: 'GET',
};
export const getOriginEnterpriseApplyInit = {
  url: 'enterprise/condition',
  type: 'GET',
};
export const originEnterpriseApprove = {
  url: 'enterprise/approve',
  type: 'POST',
};
export const originEnterpriseReject = {
  url: 'enterprise/reject',
  type: 'POST',
};
export const originEnterpriseEdit = {
  url: 'enterprise/edit',
  type: 'POST',
};
export const getOriginEnterpriseComplaintList = {
  url: 'enterprise/complaints',
  type: 'GET',
};
/** ************************* 源头企业 end ****************************** */
